// removed by extract-text-webpack-plugin
module.exports = {"Recall":"Recall__Recall___1YckP","RecallFormSection":"Recall__RecallFormSection___GWgw-","Form":"Recall__Form___1yEL-","FormInput":"Recall__FormInput___1vHN2","FormInputButton":"Recall__FormInputButton___2sahr"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/Recall/Recall.less
// module id = 1201
// module chunks = 0 1